import { address_server_short, API_V2 } from '../config';
import { error } from '../utils/handlerError';
import { axiosInstance } from './common/axios.instance';

const DEVICE_MODELS = 'device-models';

export async function getAllDevicesModels({ page, search, sorting, columns } = {}) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${DEVICE_MODELS}`, {
    withCredentials: true,
    params: {
      page,
      search,
      sorting: sorting?.field && sorting?.type ? JSON.stringify(sorting) : undefined,
      columns: columns?.length ? JSON.stringify(columns) : columns ? JSON.stringify([]) : undefined,
    },
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getAllDevicesModels', data);
}

export async function deleteDeviceModel(id) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${DEVICE_MODELS}/${id}`, {
    withCredentials: true,
    method: 'DELETE',
  });

  if (!data.success) {
    error('deleteDeviceModels', data);
  }

  return data;
}

export async function createDeviceModel(deviceModel) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${DEVICE_MODELS}`, {
    withCredentials: true,
    method: 'POST',
    data: {
      ...deviceModel,
    },
  });

  if (!data.success) {
    error('createDeviceModel', data);
  }

  return data;
}

export async function updateDeviceModel(id, deviceModel) {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${DEVICE_MODELS}/${id}`, {
    withCredentials: true,
    method: 'PUT',
    data: {
      ...deviceModel,
    },
  });

  if (!data.success) {
    error('updateDeviceModel', data);
  }

  return data;
}

export async function getDevicesModelsIcons() {
  const { data } = await axiosInstance(`${address_server_short}${API_V2}/${DEVICE_MODELS}/icons`, {
    withCredentials: true,
  });

  if (data.success) {
    if (data.result) return data.result;
    return [];
  }
  error('getDevicesModelsIcons', data);
}
